import { Component, OnInit } from '@angular/core';
import { NavbarPanelComponent } from '../../admin/paneladmin/navbar/navbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { CommonModule } from '@angular/common';
import { AuthServiceService } from './services/auth-service.service';
import { Router, RouterOutlet } from '@angular/router';
import { UserService } from './services/user.service';


@Component({
  selector: 'app-panelclient',
  standalone: true,
  imports: [RouterOutlet,NavbarPanelComponent, SidebarComponent, CommonModule],
  templateUrl: './panelclient.component.html',
  styleUrls: ['./panelclient.component.scss'],
  providers: [AuthServiceService, UserService]
})
export class PanelclientComponent  implements OnInit {
  //Variavel de controle dos menus
  public itemSelecionado: string = 'disparos';
  public menuOpen: boolean = false;

  constructor(private authService: AuthServiceService, private router: Router, private readonly userService: UserService,) { }

  ngOnInit() {
    this.authService.requestDataPeriodically().subscribe(()=> {
      console.log('Rodando requisicao de autenticacao periodica');
    },(error: any)=> {
      this.router.navigate(['/']);
    })

    this.userService.getVersion().subscribe((response)=> {
      this.insertVersionIfEmpty(response.version);
    })

  }

  public async mostrarItemSelecionado(item: string){
    this.itemSelecionado = item;
  }

  public async setStatusMenu(status: boolean) {
    this.menuOpen = status;
  }

  //CONTROL VERSION IN LOGIN APP
  public insertVersionIfEmpty(version: string): void {
    if(!localStorage.getItem('version')) {
      this.setVersion(version);
    }else{
      if(!this.compareVersion((localStorage.getItem('version') as string), version)) {
        this.equalsVersion(version);
      }
    }
  }

  public compareVersion(actual: string, newVersion: string){
    return actual === newVersion;
  }

  public setVersion(newVersion: string){
    localStorage.setItem('version', newVersion);
    this.hardReset();
  }

  public equalsVersion(version: string){
    this.setVersion(version);
  }

  public hardReset(): void{
    const url = window.location.origin + window.location.pathname + "?hard="+Date.now();

    console.log("Executando ajuste de equivalencia de versao");
    window.location.href=url;
  }

}
